import { SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_ERROR } from "../actions/user";

export default ({ user_id, user }) => (dispatch, getState) => {
  dispatch({ type: SAVE_USER });
  return fetch(`${process.env.REACT_APP_USERDATA_URI}/update/user/${user_id}`, {
    method: "POST",
    body: JSON.stringify(user)
  })
    .then(res => res.json())
    .then(payload => dispatch({ type: SAVE_USER_SUCCESS, payload }))
    .catch(({ message: payload }) =>
      dispatch({ type: SAVE_USER_ERROR, payload })
    );
};



// WEBPACK FOOTER //
// ./src/store/epics/updateUserData.js